import { BASE_URL, PERMISSIONList, PERMISSIONListADD, PERMISSIONListDELETE, PERMISSIONListUPDATE, PERMISSIONS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IPermissionListInput } from "models/permissions";


export async function getPermissionList(params: string = "") {
  const response = await axios.get(BASE_URL + PERMISSIONList + params);
  return response.data;
}

export async function addPermissionList(data: IPermissionListInput) {
  const response = await axios.post(BASE_URL + PERMISSIONListADD , data);
  return response.data;
}

export async function editPermissionList(data: IPermissionListInput, id: string) {
  const response = await axios.patch(BASE_URL + PERMISSIONListUPDATE + '/'+id, data);
  return response.data;
}

export async function deletePermissionList( id: string) {
  const response = await axios.delete(BASE_URL + PERMISSIONListDELETE + '/'+id);
  return response.data;
}

export async function getPermissions(params: string = "") {
  const response = await axios.get(BASE_URL + PERMISSIONS + params);
  return response.data;
}

export async function updatePermission(data: any, id: string) {
  const response = await axios.put(BASE_URL + PERMISSIONS + "/" + id, data);
  return response.data;
}


export const PermissionsCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
